module.exports = __webpack_public_path__ + "img/alert.b82a3f20.svg";